// removed by extract-text-webpack-plugin
module.exports = {"container":"ntVuIeXsLCnE7AmvydvrY"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Layout.css
// module id = 129
// module chunks = 0